import { Select } from "@mantine/core";
import { buildYearOptions } from "pages/admin/statements/utils";
import { useEffect } from "react";

interface IEoyYearPickerProps {
  value: string | null;
  onChange: (value: string | null) => void;
}
export const EoyYearPicker = ({ value, onChange }: IEoyYearPickerProps) => {
  const yearOptions = buildYearOptions();
  const defaultValue = yearOptions[0].value;

  // If parent passes null, auto‑select current month
  useEffect(() => {
    if (value === null) {
      onChange(defaultValue);
    }
  }, [value, defaultValue, onChange]);

  return (
    <Select
      w={300}
      label="Select Year"
      placeholder="Choose year"
      data={yearOptions}
      value={value}
      onChange={onChange}
      clearable={false}
      searchable={false}
      comboboxProps={{ withinPortal: true }}
    />
  );
};
export default EoyYearPicker;
